import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row justify-content-center" }

import router from '@/router';
import { Link } from '@/services/client/types';
import { useAuthStore } from '@/stores/authStore';
import { useLinkStore } from '@/stores/linkStore';
import { useUserStore } from '@/stores/userStore';
import { onMounted, ref } from 'vue';
import Card from '../components/Card.vue';

// Stores

export default /*@__PURE__*/_defineComponent({
  __name: 'Overview',
  setup(__props) {

const authStore = useAuthStore()
const userStore = useUserStore()
const linkStore = useLinkStore()

const links = ref<Link[]>([])

onMounted(async () => {
  console.log(`Requesting user links...`)
  if (!authStore.user?.id) throw new Error(`Could not find user data in authStore. User is possibly unauthenticated. Reset your cache.`);
  const userId = authStore.user.id
  const user = await userStore.getUser(userId)
  if (!user) throw new Error(`Could not retrieve user data from userStore. Try to reset your cache.`);
  links.value = await linkStore.fetchLinksForUser(user)
  console.log(`Received links: `, links)
})

console.log("Links in store:", links)

function viewQuestion(id: number) {
  console.log('Viewing data for question:', id);
  router.push(`/data/${id}?no_container=true`) // Set to false to set default behaviour for showing container to false
  // Navigate or fetch data for the question
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("h1", { class: "mb-4" }, "Overview", -1)),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(links.value, (link) => {
        return (_openBlock(), _createElementBlock("div", {
          key: link.id,
          class: "col-md-4 d-flex justify-content-center align-items-stretch"
        }, [
          _createVNode(Card, {
            name: link.title,
            onClick: ($event: any) => (viewQuestion(link.id))
          }, null, 8, ["name", "onClick"])
        ]))
      }), 128))
    ])
  ]))
}
}

})